import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { severityTypes } from './util/constants';
import { NotificationsSeverity } from './notifications-severity';

export const Content = (props) => {
  const notificationsSeverityComponents = _.chain(severityTypes)
    .map(severity => ({
      severity,
      notificationList: _.filter(props.notifications, notification =>
        notification.severity && notification.severity === severity),
    }))
    .filter(({ notificationList }) => !_.isEmpty(notificationList))
    .map(severityProps => (
      <NotificationsSeverity
        key={severityProps.severity}
        {...severityProps}
        actionCallback={props.actionCallback}
        isUINext={props.isUINext}
        i18n={props.i18n}
        logger={props.logger}
        logContent={props.logContent}
      />
    ))
    .value();

  return (
    <div className="notification-queue-content">
      {notificationsSeverityComponents}
    </div>
  );
};

Content.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
  actionCallback: PropTypes.func.isRequired,
  isUINext: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    trace: PropTypes.func,
  }),
  logContent: PropTypes.func,
};

Content.defaultProps = {
  logger: {
    trace: _.noop,
  },
  logContent: _.noop,
};
